/**
 在线运维--指标数据下载
 */
import React, { Component } from "react";
import moment from "moment";
import Axios from "axios";
import { Spin, message } from "antd";
import { prefixFile } from "@/fetch/fetchApi";
import AddDownloadTask from "./addDownloadTask";

class IndicatorDateDownload extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showSpinning: false, // 加载loading 开启/关闭 标识
      data: this.props.params,
      fileName: "", // 导出文件文件名
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  // 调用接口导出数据
  exportData(param) {
    const url = `${prefixFile}/api/indicator/export`;
    Axios.get(url, {
      params: param,
      responseType: "blob",
      headers: {
        Authorization: window.sessionStorage.getItem("token"),
      },
    })
      .then((res) => {
        const blob = res.data;
        const fileName = `${this.state.fileName}.xls`;
        const csvUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = fileName; // 文件名字
        link.href = csvUrl;
        // 触发下载
        link.click();
        // document.body.removeChild(link);

        ///
        // let reader = new FileReader();
        // reader.readAsDataURL(blob);
        // reader.onload = (e)=>{
        //     console.log(fileName)
        //     console.log(e)
        //     let ele = document.createElement('a');
        //     ele.download = fileName
        //     ele.href=e.target.result;
        //     document.body.appendChild(ele);
        //     ele.click();
        //     document.body.removeChild(ele);
        // }
        this.setState({
          showSpinning: false,
        });
      })
      .catch((err) => {
        message.error(err.message ? err.message : err);
        this.setState({
          showSpinning: false,
        });
      });
  }

  /**
   * 获取子组件传递过来的数据，并进行处理
   */
  getInfo(info) {
    const param = {
      dType: info.dType,
      dataDim: info.dataDim,
      cityIds: info.selectCityType === "2" ? info.cityIds : "",
      provinceIds: info.selectCityType === "0" || info.selectCityType === "1" ? info.cityIds : "",
      operationProperty: "3",
      operationMode: info.operationMode,
      type: info.type,
      isSummary: info.isSummary,
      startTime: info.startTime,
      endTime: info.endTime,
    };
    const dimName = info.dType === "1" ? "终端" : "订单";
    const LIMIT_DAY_NUMBER = 31; // 限制查询天数
    // 判断时间相差天数校验
    if (info.timeDimention === "0") {
      const diff = moment(param.endTime).diff(moment(param.startTime), "day");
      if (info.dataDim === "2") {
        if (info.dType === "1") {
          // 设备完好率-终端维度
          if (diff >= LIMIT_DAY_NUMBER) {
            this.setState({
              showSpinning: false,
            });
            message.error(`${dimName}维度按日查询日期不能超过${LIMIT_DAY_NUMBER}天`);
            return;
          }
        } else {
          // 充电成功率-订单维度
          if (diff >= LIMIT_DAY_NUMBER) {
            this.setState({
              showSpinning: false,
            });
            message.error(`${dimName}维度按日查询日期不能超过${LIMIT_DAY_NUMBER}天`);
            return;
          }
        }
      } else {
        if (diff >= LIMIT_DAY_NUMBER) {
          this.setState({
            showSpinning: false,
          });
          message.error(`查询日期不能超过${LIMIT_DAY_NUMBER}天`);
          return;
        }
      }
    } else {
      const diff = moment(param.endTime).diff(moment(param.startTime), "month");
      if (info.dataDim === "2") {
        if (diff >= 6) {
          this.setState({
            showSpinning: false,
          });
          message.error(`${dimName}维度按月查询，日期不能超过半年`);
          return;
        }
      }
      // else {
      //     if(diff >= 12){
      //         this.setState({
      //             showSpinning:false
      //         })
      //         message.error('查询日期不能超过1年')
      //         return
      //     }
      // }
    }

    // 拼接导出文件名
    const timeInfo =
      param.startTime === param.endTime ? param.startTime : `${param.startTime}至${param.endTime}`;
    const summaryInfo = param.isSummary === "0" ? "细分" : "汇总";
    let dataDim = "";
    if (param.dataDim === "0") {
      dataDim = "地区";
    } else if (param.dataDim === "1") {
      dataDim = "电站";
    } else {
      dataDim = dimName;
    }
    const dayType = info.timeDimention === "0" ? "按天" : "按月";
    const dType = param.dType === "1" ? "设备完好率" : "充电成功率";
    const fileName = `${timeInfo + dayType + summaryInfo + dType}-${dataDim}指标`;

    this.setState(
      {
        startTime: info.startTime,
        endTime: info.endTime,
        showSpinning: true,
        fileName: fileName,
      },
      () => {
        this.exportData(param);
      },
    );
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-panel" style={{ padding: "20px" }}>
          <Spin tip="数据生成中，请等待" spinning={this.state.showSpinning}>
            <AddDownloadTask
              getInfo={(msg) => {
                this.getInfo(msg);
              }}
            />
          </Spin>
        </div>
      </div>
    );
    return Content;
  }
}

export default IndicatorDateDownload;



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/IndicatorDataDownload/indicatorDateDownload.js